import { useEffect, useState } from 'react'

import config from 'config'

const useFetch = (endpoint, options = {}) => {
  const [status, setStatus] = useState({ loading: true, error: null, data: null })

  useEffect(() => {
    fetch(`${config.apiUrl}${endpoint}`)
      .then(res => {
        return res.json()
      })
      .then(res => {
        if (!res.success) throw res
        if (typeof options.onSuccess === 'function') {
          options.onSuccess(res.data)
        }
        return setStatus({ loading: false, error: false, data: res.data })
      })
      .catch(err => {
        if (typeof options.onError === 'function') {
          options.onError(err)
        }
        return setStatus({ loading: false, error: err, data: null })
      })
  }, [])

  return status
}

export default useFetch
